import { CircleAlertIcon } from '@persona-id/design-tokens/icons';
import { FunctionComponent } from 'react';

import ProductFeatureGated from 'dashboard/components/ProductFeatureGated';
import { ProductFeatureName } from 'dashboard/models/organization';
import Banner from 'design-system/components/Banner';
import { Paragraph } from 'design-system/components/Text';

export const ProductFeatureContactUsBanner: FunctionComponent = () => (
  <ProductFeatureGated invert productFeatureFlag={ProductFeatureName.WorkflowsEnhanced}>
    <Banner variant='alert' css={{ marginBottom: '20px', padding: '8px' }}>
      <CircleAlertIcon />
      <Paragraph size='lg'>
        You do not have access to this feature.{' '}
        <a href='https://withpersona.com/contact'>Contact us</a> if you are interested.
      </Paragraph>
    </Banner>
  </ProductFeatureGated>
);
